import React from 'react';
import '../../tailwind.css';
import { IContentContainer } from '../../types/ContentContainer.types';

const ContentContainer: React.FC<IContentContainer> = (props) => {
  return (
    <div
      className={`mx-auto max-w-app-column pt-24px pb-72px ${props.tabBarDisabled ? '!pb-bottom-no-tabs' : ''}`}
      id={props.id}
      style={props.style}>
      {props.children}
    </div>
  );
};

export default ContentContainer;
